import RecoveryContainer from '../../containers/auth/RecoveryContainer'

const RecoveryPage = () => {
  return <RecoveryContainer />
}
export default RecoveryPage
